/**
 * @description 将扁平化数组转化为树形结构数据
 * @param {Array} data - 输入的数据数组，其中每个对象表示树的一个节点，包含id（节点ID）和pid（父节点ID）属性。
 * @param {Object} config - 配置对象，可选参数，用于自定义关键字段的名称。
 *   - rootId {Number|String} - 默认值为0，指定作为树结构根节点的id值。
 *   - idName {String} - 默认值为'id'，指定数据项中代表节点id的属性名称。
 *   - pidName {String} - 默认值为'pid'，指定数据项中代表父节点id的属性名称。
 *   - rootFidValue {Number|String} - 默认值为'0'，指定根节点的pid值，默认情况下根节点的pid为0或'0'。
 *   - childrenName {String} - 默认值为'children'，在生成的树形结构中，子节点列表所对应的属性名称。
 * @return {Array} 返回一个树形结构的数组，其中每个对象除了原始数据属性外，还包含一个名为children的属性，用于存储该节点的子节点数组。
 */
export function buildTree(data, config) {
  if (data.constructor !== Array) throw new Error('buildTree传入data数据需要是数组类型')
  const {
    idName = 'id',
    pidName = 'pid',
    rootFidValue = '0', //如果根节点的pid不是null，而是0，就需要特别处理
    childrenName = 'children',
  } = config

  //特别处理根节点，pid从0改为null
  if (rootFidValue)
    data.forEach((item) => {
      if (item[pidName] === rootFidValue) item[pidName] = null
      return item
    })

  function arrToTree(arr, id) {
    const res = []
    arr.forEach((item) => {
      if (item[pidName] === id) {
        const children = arrToTree(arr, item[idName])
        if (children.length) item[childrenName] = children
        res.push(item)
      }
    })
    return res
  }

  return arrToTree(data, null)
}

export function searchTree(name, data, tree) {
  if (data === '') return tree
  const newTree = JSON.parse(JSON.stringify(tree))
  function filterTree(node) {
    if (node.children?.length) {
      node.children = node.children.filter((chill) => {
        return filterTree(chill) !== null
      })
    }
    if (!node.children?.length && !node[name].includes(data)) return null
    return node
  }
  return newTree.filter((rootNode) => filterTree(rootNode) !== null)
}
